import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserActions } from '../state/user'
import { State } from '../types/state'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'

export const FetchDataComponent = (): JSX.Element => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()
  const { shouldRefreshUserState } = useSelector(
    (state: State) => state.refresh
  )

  const fetchUserData = async (): Promise<void> => {
    const username = localStorage.getItem('Kreatlo-usernmae')
    const password = localStorage.getItem('Kreatlo-password')
    const token = localStorage.getItem('Kreatlo-jwtToken')
    const googleToken = localStorage.getItem('Kreatlo-googleToken')

    if (token !== null) {
      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    } else if (username !== null && password !== null) {
      const tokenResponse = await requestMaker.getToken({
        username,
        password
      })
      localStorage.setItem(
        'Kreatlo-jwtToken',
        tokenResponse.data.Authorization
      )

      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    } else if (googleToken !== null) {
      const tokenResponse = await requestMaker.getToken({
        googleToken
      })
      localStorage.setItem(
        'Kreatlo-jwtToken',
        tokenResponse.data.Authorization
      )

      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    }
    dispatch(RefreshActions.setUserStateFetched())
  }

  useEffect(() => {
    if (shouldRefreshUserState) {
      void fetchUserData()
      dispatch(RefreshActions.setUserStateRefreshed())
    }
  }, [shouldRefreshUserState, fetchUserData])

  return <></>
}
